import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { CONS } from '@pomofocus/core';
import { useAppSelector, configSelectors, useAppDispatch, configActions, } from '@pomofocus/shared-client';
import Selections from '../../common/Selections';
import { ENV, HOUR_FORMAT_SELECTION } from '../../../constants';
import { ColorSelectDropdown } from './common/ColorSelectDropdown';
import { Clickable } from '../../styles/Animation';
import { IconSets } from '../../common/IconSets';
import { FormBlock, FlexWrapper, FormHeader, FormHeaderText, SectionWrapper, } from './common';
import { Button } from '../../common/Button';
export function ThemeConfig() {
    const dispatch = useAppDispatch();
    const configObj = useAppSelector(configSelectors.selectConfigObj);
    const updateConfigObj = (config) => {
        dispatch(configActions.updateConfigObj(config));
    };
    const [colorDropdownVisible, setColorDropdownVisible] = useState(false);
    const [activeItemIndex, setActiveItemIndex] = useState(0);
    // const [dropdownPosition, setDropdownPosition] = useState({
    //   top: 0,
    //   left: 0,
    // });
    const dropdownRef = useRef(null);
    function handleSwitchDarkMode() {
        updateConfigObj({
            ...configObj,
            darkModeEnabled: !configObj.darkModeEnabled,
        });
    }
    function handleSelectHourFormat(hourFormatId) {
        updateConfigObj({
            ...configObj,
            hourFormat: hourFormatId,
        });
    }
    const openSelectWindow = (index) => {
        // const target = event.currentTarget as HTMLElement;
        // const rect = target.getBoundingClientRect();
        setActiveItemIndex(index);
        // setDropdownPosition({
        //   top: rect.height + 8,
        //   left: 0,
        // });
        setColorDropdownVisible(true);
    };
    const handleChangeColor = (color) => {
        const newColorThemes = [...configObj.colorThemes];
        newColorThemes[activeItemIndex] = color;
        updateConfigObj({
            ...configObj,
            colorThemes: newColorThemes,
        });
        setColorDropdownVisible(false);
    };
    const onClickSmallWindow = () => {
        window.open(`${ENV.BASE_URL}/app`, 'Pomofocus', 'height=2000,width=10');
    };
    return (React.createElement(SectionWrapper, { subHeader: "Theme", SubHeaderIcon: React.createElement(IconSets, { name: "Style" }) },
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Color Themes")),
                React.createElement(ColorItemWrapper, { ref: dropdownRef },
                    React.createElement(ColorItem, { color: CONS.COLORS.THEME[configObj.colorThemes[0]], onClick: () => openSelectWindow(0) }),
                    React.createElement(ColorItem, { color: CONS.COLORS.THEME[configObj.colorThemes[1]], onClick: () => openSelectWindow(1) }),
                    React.createElement(ColorItem, { color: CONS.COLORS.THEME[configObj.colorThemes[2]], onClick: () => openSelectWindow(2) }),
                    React.createElement(ColorSelectDropdown, { visible: colorDropdownVisible, closeDropdown: () => setColorDropdownVisible(false), activeItemIndex: activeItemIndex, onChange: handleChangeColor, colorThemes: configObj.colorThemes, top: 38, right: 10, dropdownRef: dropdownRef })))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Hour Format")),
                React.createElement(NotificationWrapper, null,
                    React.createElement(Selections, { selectedId: configObj.hourFormat, handleSelect: handleSelectHourFormat, selection: HOUR_FORMAT_SELECTION, idAttr: "id", textAttr: "text", width: 130, fontSize: 14 })))),
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Dark Mode when running")),
                React.createElement(Switch, { enabled: configObj.darkModeEnabled, onClick: handleSwitchDarkMode },
                    React.createElement(Switcher, null)))),
        !isMobile && (React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Small Window")),
                React.createElement(Button, { theme: "secondary", size: "small", onClick: onClickSmallWindow },
                    "Open ",
                    React.createElement(ButtonIcon, { src: "/icons/external-link.svg" })))))));
}
const NotificationWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const ColorItemWrapper = styled.div `
  display: flex;
  gap: 0.7rem;
  position: relative;
`;
const ColorItem = styled.div `
  ${Clickable}
  background-color: ${(props) => props.color};
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 0.4rem;
`;
const ButtonIcon = styled.img `
  width: 12px;
  margin-left: 4px;
  opacity: 0.7;
`;
const Switch = styled.div `
  cursor: pointer;
  width: 60px;
  height: 32px;
  border-radius: 50px;
  background-color: #ccc;
  position: relative;
  display: inline-flex;
  align-items: center;
  ${(props) => props.enabled &&
    `
		background-color: hsla(87, 59%, 49%, .8);
		& div {
			right: 2px;
			left: auto;
		}
	`}
`;
const Switcher = styled.div `
  position: absolute;
  left: 2px;
  width: 28px;
  height: 28px;
  border-radius: 50px;
  background-color: white;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
`;
